<div class="casinolobbycontainer">
  <div class="box golden-race" *ngFor="let item of gameTypes" (click)="goGames(item)" [ngStyle]="{ 'background-image': 'url(' + item.thumbnail + ')' }">
    <span>{{ item.gameTitle }}</span>
  </div>
</div>
